import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {ConfigurationModel} from "../../ek-e-commerce/ek-models/configuration.model";
import {QueryParamsModel} from "../../_base/crud";
import {Response} from "../../_base/crud/models/response";
import {Action, createReducer, on} from "@ngrx/store";
import * as ConfigurationActions from "../_actions/bestSells.action";


export interface BestSellsState extends EntityState<ConfigurationModel> {
    listLoading: boolean;
    actionsLoading: boolean;
    totalCount: number;
    lastCreatedConfigurationId: number;
    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
    error: any;
    lastAction: string;
}

export const adapter: EntityAdapter<ConfigurationModel> = createEntityAdapter<ConfigurationModel>();

export const initialConfigurationState: BestSellsState = adapter.getInitialState({
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    lastCreatedConfigurationId: undefined,
    lastQuery: new QueryParamsModel({}),
    showInitWaitingMessage: true,
    error: Response,
    lastAction: '',
});

const bestSellReducer = createReducer(
    initialConfigurationState,
    on(ConfigurationActions.BestSellsPageRequested,
        state => ({
            ...state,
            actionsLoading: true,
            listLoading: true,
            showInitWaitingMessage: true,
            error: null,
            lastAction: ''
        })),
    on(ConfigurationActions.BestSellsPageLoadedSuccessfully,
        (state, action) => (adapter.addAll(action.configurations,
            {
                ...state,
                actionsLoading: false,
                listLoading: false,
                showInitWaitingMessage: false,
                // totalCount: action.totalCount
            }))),
    //
    // on(ConfigurationActions.ConfigurationsPageLoadedSuccessfully1,
    //     (state, action) => (adapter.addAll(action.configurations,
    //         {
    //             ...state,
    //             actionsLoading: false,
    //             listLoading: false,
    //             showInitWaitingMessage: false,
    //             totalCount: action.totalCount
    //         }))),
    on(ConfigurationActions.BestSellsPageLoadFailed,
        (state, action) => ({
            ...state,
            actionsLoading: false,
            listLoading: false,
            showInitWaitingMessage: false,
            error: action.error
        })),
    //creation
    on(ConfigurationActions.BestSellsCreated,
        (state) => ({...state, actionsLoading: true, lastAction: ''})),
    on(ConfigurationActions.BestSellsCreatedSuccessfully,
        (state, action) => (adapter.addOne(action.configuration, {
            ...state,
            actionsLoading: true,
            lastCreatedConfigurationId: action.configuration.id,
            lastAction: 'EDIT.ADD_MESSAGE'
        }))),
    on(ConfigurationActions.BestSellsCreationFailed,
        (state, action) => ({...state, actionsLoading: false, error: action.error})),
    //Update
    on(ConfigurationActions.BestSellsUpdated,
        (state) => ({...state, actionsLoading: true, lastAction: ''})),
    on(ConfigurationActions.BestSellsUpdatedSuccessfully,
        (state, action) =>
            (adapter.updateOne(action.partialConfiguration, {
                ...state,
                actionsLoading: false,
                lastAction: 'EDIT.UPDATE_MESSAGE'
            }))),
    on(ConfigurationActions.BestSellsUpdateFailed,
        (state, action) => ({...state, actionsLoading: false, error: action.error})),
    // //Update Activate
    // on(ConfigurationActions.ConfigurationUpdatedActivate,
    //     (state) => ({...state, actionsLoading: true, lastAction: ''})),
    // on(ConfigurationActions.ConfigurationUpdatedActivateSuccessfully,
    //     (state, action) =>
    //         (adapter.updateOne(action.partialConfiguration, {
    //             ...state,
    //             actionsLoading: false,
    //             lastAction: 'EDIT.UPDATE_MESSAGE'
    //         }))),
    // on(ConfigurationActions.ConfigurationUpdateActivateFailed,
    //     (state, action) => ({...state, actionsLoading: false, error: action.error})),
    //Delete
    on(ConfigurationActions.BestSellsDeleted,
        (state, action) => ({...state, actionsLoading: true, lastAction: ''})),
    on(ConfigurationActions.BestSellsDeletedSuccessfully,
        (state, action) => (adapter.removeOne(action.configurationId, {
            ...state,
            actionsLoading: false,
            lastAction: 'DELETE.DELETE_CONFIGURATION_SIMPLE.DELETE_SUCCESS'
        }))),
    on(ConfigurationActions.BestSellsDeleteFailed,
        (state, action) => ({...state, error: action.error, actionsLoading: false}))
);

export function bestSellsReducer(state: BestSellsState | undefined, action: Action) {
    return bestSellReducer(state, action)
}
